/**
 * @module profile/components/brief
 */

import React, { PropTypes } from 'react';
import BriefHead from 'project/containers/brief_head';
import BriefHead1to1 from 'project/containers/brief_head_1_1';
import SuggestedCreatives1to1 from 'project/containers/suggested_creatives_1_1';
import WorkWith1to1 from 'project/components/brief/work_with_1_1';
import Pay1to1 from 'project/containers/pay_1_1';
import Updates from 'project/containers/brief_updates';
import Background from 'project/components/brief/background';
import Execution from 'project/components/brief/execution';
import Materials from 'project/components/brief/materials';
import LegacyBrief from 'project/components/brief/legacy';
import NDAd from 'project/containers/brief_ndad';
import WinnerEntryBanner from 'entries/containers/winner_banner';
import ParticipationPermsCallout from 'project/containers/participation_perms_callout';
import NEGOTIATION_STATUSES from 'project/statuses_1_1';
import { isCollaborator } from 'project/utils';
import LoginRequired from 'project/containers/login_required';
import GiveBackCallout from 'project/components/give_back_callout';

/**
 * Project brief main component
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 *
 * @return {void}
 */
const ProjectBrief = ({ project, user, loginRequired, showWinnerBanner }) => {
  const show1to1Header = project.is_one_to_one && project.status === '1_1_negotiating';
  const show1to1Creatives = (
    project.is_one_to_one &&
    project.client * 1 === user.id * 1 &&
    NEGOTIATION_STATUSES(project)[project.one_to_one_negotiation_status].showSuggestedCreatives
  );

  const showPay1to1 = (
    project.is_one_to_one &&
    project.client * 1 === user.id * 1 &&
    project.status === '1_1_negotiating' &&
    ['client_accepted', 'creative_accepted'].includes(project.one_to_one_negotiation_status)
  );

  const showNDAd = (
    project.nda_required && project.client !== user.id && !isCollaborator(project)
    && project.nda_request_status !== 'accepted'
  );

  return (
    <div className="project-brief">
      {showWinnerBanner && <WinnerEntryBanner />}

      <ParticipationPermsCallout />

      {show1to1Header
        ? <BriefHead1to1 project={project} user={user} />
        : <BriefHead project={project} />
      }

      <div className="brief-content">
        <div className="row">
          {loginRequired && <div className="columns small-16"><LoginRequired /></div>}
          {!loginRequired && <div className="columns small-16">
            { showNDAd && <NDAd /> }

            { project.give_back && <GiveBackCallout /> }

            { show1to1Creatives &&
            <SuggestedCreatives1to1 subCategoryId={project.sub_category}
              excludeIds={project.one_to_one_declined_creative_ids} /> }

            { showPay1to1 && <Pay1to1 /> }

            <div className={showPay1to1 ? 'faded' : ''}>
              { !showNDAd && <Updates /> }

              {project.is_one_to_one && <WorkWith1to1 project={project} user={user} />}

              {project.is_legacy && <LegacyBrief project={project} showNDAd={showNDAd} />}

              {!project.is_legacy && <Background project={project} sensitive={showNDAd} />}

              {!project.is_legacy && !showNDAd && <Execution project={project} />}

              {!showNDAd && <Materials project={project} />}
            </div>
          </div>}
        </div>
      </div>
    </div>);
};

ProjectBrief.propTypes = {
  project: PropTypes.object,
  user: PropTypes.object,
  loginRequired: PropTypes.bool,
  showWinnerBanner: PropTypes.bool,
};

export default ProjectBrief;



// WEBPACK FOOTER //
// ./project/components/brief.jsx